<template>
  <div class="row search-text-entry-container">
    <div class="col-md-11 col-sm-12 pl-0">
      <div class="row">
        <slot></slot>
      </div>
    </div>
    <div class="col-md-1 col-sm-12 p-md-0 pt-md-0 pr-sm-3 pt-sm-2 mt-2 mt-md-0 mt-sm-2">
      <action-button
        variant="success float-right"
        text="Buscar"
        min-width="100px"
        @click="searchClicked"
      ></action-button>
    </div>
  </div>
</template>

<script>
import ActionButton from '@/components/common/ActionButton'
export default {
  name: 'SearchCriteriaEntry',
  components: {
    ActionButton,
  },
  /*
  props: {
    placeHolderText: { type: String, default: '' },
    maxLength: {type:Number, default:100}
  },
  */
  methods: {
    searchClicked() {
      this.$emit('searchClicked')
    },
  },
}
</script>

<style scoped>
.search-text-entry-container {
  padding: 15px;
  background-color: #f4f6f3;
}

.search-text-entry-container input {
  border: #e2e2e2 solid 1px;
  color: #495057;
  font-weight: bold;
}

.input-icon {
  background-color: white;
  color:#FF7058;
}
/**ECG: for v-select criteria */

.v-select {
  background-color: white;
}

.v-select >>> .vs__dropdown-toggle {
  padding: 6px;
  border: #e2e2e2 solid 1px;
}

.v-select >>> .vs__search {
  margin-top: 0;
  color: #495057;
  font-weight: bold;
}

.v-select >>> .vs__selected {
  margin: 0;
}

.v-select >>> .vs__clear {
  height: 20px;
}

.v-select >>> .vs__clear svg {
  vertical-align: baseline;
  margin-bottom: 3px;
}
</style>
